import { useSearchParams } from 'next/navigation';

export const useIsLeasePage = () => {
  const searchParams = useSearchParams();

  if (!searchParams || typeof searchParams.get !== 'function') {
    return false;
  }

  return searchParams.get('lease') === '1';
};
